/**
 * Login (and similar auth forms) surface API failures with local MUI `Alert` state.
 * Do not also forward the same string to App’s global Snackbar — that duplicates the message.
 */

export const LOGIN_FAILURE_FALLBACK = 'Login failed. Please check your credentials and try again.';

export function showLoginFailureAlert(setError, message) {
  const text = typeof message === 'string' && message.trim() ? message.trim() : LOGIN_FAILURE_FALLBACK;
  setError(text);
}
